import { useEffect, useState } from 'react';
import getStateManager from '../StateManager';
import { useAddress } from './addressHook';
import { useAuth } from './authHook';

// Latest released firmware versions per controller type, refetched whenever
// `refreshKey` (the connection status) changes.
export function useFirmwareVersions(refreshKey) {
  const address = useAddress();
  const auth = useAuth();
  const [firmwareVersions, setFirmwareVersions] = useState({
    5053: [],
    5052: [],
    5055: [],
    5155: [],
    6000: []
  });

  useEffect(() => {
    const stateManager = getStateManager();
    const request = new AbortController();
    if (auth.user) {
      fetch(address.api_url('/api/versions'), { signal: request.signal })
        .then(async (response) => {
          if (!response.ok) return;
          const data = await response.json();
          if (!request.signal.aborted && stateManager.store() === stateManager)
            setFirmwareVersions({ ...data.version_numbers });
        })
        .catch((error) => {
          if (!request.signal.aborted && stateManager.store() === stateManager)
            console.warn('[firmware-versions] request failed', error);
        });
    }
    return () => request.abort();
  }, [auth.user, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return firmwareVersions;
}
